import React, { useEffect } from "react";
import mixpanel from "mixpanel-browser";

const withMixpanel = (WrappedComponent) => {
  return function MixpanelComponent(props) {
    useEffect(() => {
      mixpanel.init("40a25afaf27362a7bbb2eff161ec5e53", {
        debug: true,
        track_pageview: true,
        persistence: "localStorage",
      });
      mixpanel.track_pageview();
      const userData = props?.state?.pageData?.userData;
      if (userData?._id) {
        mixpanel.identify(userData._id);
      }
      const handleClick = (event) => {
        const element = event.target;
        const tagName = element.tagName.toLowerCase();
        const id = element.id;
        
        // Safe className handling
        const classes = typeof element.className === 'string' 
          ? element.className.split(" ") 
          : [];
          
        const analyticsTag = element.getAttribute("data-analytics");

        if (tagName === "a" || tagName === "button" || analyticsTag) {
          let eventProperties;
          if (!analyticsTag) {
            eventProperties = { id, classes, type: "click" };
          } else {
            eventProperties = {
              flow: element.getAttribute("data-analytics-flow"),
              section: element.getAttribute("data-analytics-section"),
              type: element.getAttribute("data-analytics-type")
            };
            trackEvent(analyticsTag, eventProperties);
          }
        }
      };
      document.addEventListener("click", handleClick);

      return () => {
        document.removeEventListener("click", handleClick);
      };
    }, []);
    const trackEvent = (eventName, eventProperties) => {
      mixpanel.track(eventName, eventProperties);
    };
    return <WrappedComponent trackEvent={trackEvent} {...props} />;
  };
};
export default withMixpanel;
